
export default "/assets/arrow-left-micro.4000bf25.svg"